import { Controller } from "stimulus";
import notify from "../packs/notify";
import axios from "axios";
import i18next from "i18next";
export default class extends Controller {
  static targets = [
    "assignResultButton",
    "parentCheckbox",
    "childCheckbox",
    "parentForm",
    "pencilSpecimen",
    "specimenFrame",
    "plusSpecimen",
    "specimenTestBlock",
    "closeBulkFormButton",
    "switchView",
    "lazyPagination",
    "specimensBlock",
  ];

  static values = {
    testIdentifier: String,
    accessionIds: Array,
  };

  initialize() {
    this.initViewSwitch();
  }

  connect() {
    this.clearCheckboxes();
    this.element.addEventListener("turbo:frame-render", (e) =>
      this.handleFrame(e),
    );

    addEventListener("turbo:before-frame-render", (event) => {
      const originalRender = event.detail.render;
      event.detail.render = (currentElement, newElement) => {
        newElement.classList.add("fade-in");

        document.startViewTransition(() =>
          originalRender(currentElement, newElement),
        );
      };
    });

    this.delayTimer = null;
  }

  initViewSwitch() {
    $(this.switchViewTarget).bootstrapSwitch({
      onColor: "success",
      offColor: "danger",
      onText: "ON",
      offText: "OFF",
      size: "mini",
      onSwitchChange: function (_, state) {
        this.loadView(state);
      }.bind(this),
    });
  }

  loadView(state) {
    axios({
      url: "/test_results/bulk_test_results_assign_view",
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
      data: {
        test_identifier: this.testIdentifierValue,
        accession_ids: this.accessionIdsValue.join(","),
        compact_view: state,
      },
    }).then((html) => {
      this.element.querySelector("#specimens").innerHTML = "";
      this.element.querySelector("#pagination").innerHTML = "";
      this.closeBulkFormButtonTarget.click();
      this.disableAssignResultButton();
      this.parentCheckboxTarget.checked = false;
      this.clearElement(this.parentFormTarget);
      Turbo.renderStreamMessage(html.data);
    });
  }

  childCheckboxTargetConnected(target) {
    if (this.parentCheckboxTarget.checked) {
      target.checked = true;
    }

    if (this.isParentFormActive) {
      target.disabled = true;
    }

    if (this.switchViewTarget.checked) {
      target.addEventListener("keyup", this.handleTabKey.bind(this));
      target.addEventListener("keydowm", this.handleTabBlur.bind(this));
    }
  }

  childCheckboxTargetDisconnected(target) {
    target.removeEventListener("keyup", this.handleTabKey.bind(this));
    target.removeEventListener("keydowm", this.handleTabKey.bind(this));
  }

  handleTabBlur() {
    clearTimeout(this.delayTimer);
  }

  handleFrame(e) {
    let element = e.target;

    if (!!element.querySelector("#specimenFrameForm")) {
      this.handleFrameForm(element);
    }

    if (!!element.querySelector("#specimenBulkFrame")) {
      this.handleBulkForm(element);
    }
  }

  handleFrameForm(element) {
    const iconElement = this.getIconElemenById(element.id);
    this.changeDataIcon(iconElement, "fa-plus");
  }

  handleBulkForm(element) {
    this.closeBulkFormButtonTarget.classList.remove("d-none");
    this.assignResultButtonTarget.classList.add("d-none");
    let reloadSpecimens = this.reloadSpecimensBlock.bind(this);
    $(element)
      .find("form#test_result_entry")
      .on("ajax:success", (e, data) => {
        if (!(e.target instanceof HTMLFormElement)) return;

        notify({ message: data.message, status: data.status });
        this.clearCheckboxes();
        this.closeBulkFormButtonTarget.classList.add("d-none");
        this.clearElement(element);
        this.assignResultButtonTarget.classList.toggle("disabled");
        this.assignResultButtonTarget.classList.remove("d-none");

        this.handleFollowOnTestsModal(
          data.follow_on_test_data,
          data.delayed_job,
        );
        reloadSpecimens();
        this.parentCheckboxTarget.disabled = false;
      })
      .on("ajax:error", () => {
        notify({ message: "Something went wrong", status: "error" });
      });
  }

  handleFollowOnTestsModal(followOnTestData, delayedJob) {
    if (followOnTestData?.follow_on_test_ids?.length > 0) {
      axios({
        url: "/test_results/follow_on_tests_modal",
        method: "POST",
        data: {
          follow_on_test_data: followOnTestData,
          delayed_job: delayedJob,
        },
      }).then((res) => {
        // We used here innerHTML. It can be refactored to morphdom
        // https://github.com/patrick-steele-idem/morphdom
        document.querySelector("turbo-frame#modal").innerHTML = res.data;
      });
    }
  }

  releaseAllTests(e) {
    e.preventDefault();

    // during request disable button and change text
    e.target.disabled = true;
    const disableWithText = e.target.dataset.disableWith;
    const buttonText = e.target.textContent;
    e.target.textContent = disableWithText;
    let reloadSpecimens = this.reloadSpecimensBlock.bind(this);

    axios({
      url: "/specimen_test_schedules/mark_all_as_released",
      method: "POST",
      data: {
        accession_ids: this.accessionIdsValue,
        test_identifier: this.testIdentifierValue,
      },
    })
      .then((res) => {
        notify({ status: res.data.status, message: res.data.message });
        reloadSpecimens();
        this.handleFollowOnTestsModal(res.data.follow_on_test_data, false);
      })
      .finally(() => {
        e.target.disabled = false;
        e.target.textContent = buttonText;
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      });
  }

  openFrameForm(specimen_id, stsIds) {
    const params = new URLSearchParams();

    stsIds.forEach((id) => params.append("sts_ids[]", id));

    const url =
      `/test_results/${specimen_id}/specimen_test_schedule_form?` +
      params.toString();

    Turbo.visit(url, {
      frame: `specimen_${specimen_id}_sts_${stsIds.join("_")}`,
    });
  }

  handleTabKey(event) {
    event.preventDefault();

    const specimenId = event.target.dataset["id"];
    const stsIds = event.target.dataset["stsIds"];
    const stsIdsParse = JSON.parse(stsIds);

    if (event.key === "Tab") {
      clearTimeout(this.delayTimer);

      this.delayTimer = setTimeout(() => {
        this.scrollToSpecimenForm(stsIdsParse);
        this.openFrameForm(specimenId, stsIdsParse);
      }, 1000);
    }
  }

  clearCheckboxes() {
    this.parentCheckboxTarget.checked = false;

    this.childCheckboxTargets.forEach((element) => {
      element.checked = false;
    });
  }

  checkAll() {
    this.changeAssignResultStatus();
  }

  checkOne() {
    this.changeAssignResultStatus();
  }

  changeAssignResultStatus() {
    if (this.childCheckboxTargets.some((e) => e.checked)) {
      this.enableAssignResultButton();
    } else {
      this.disableAssignResultButton();
    }
  }

  enableAssignResultButton() {
    this.assignResultButtonTarget.classList.remove("disabled");
    this.assignResultButtonTarget.classList.add("enabled");
  }

  disableAssignResultButton() {
    this.assignResultButtonTarget.classList.remove("enabled");
    this.assignResultButtonTarget.classList.add("disabled");
  }

  bulkResultsForm(e) {
    const checkboxes = this.childCheckboxTargets;
    checkboxes.push(this.parentCheckboxTarget);

    e.preventDefault();
    e.target.disabled = true;
    e.target.querySelector(".spinner-border").classList.remove("d-none");
    checkboxes.forEach((e) => (e.disabled = true));

    axios({
      url: "/test_results/mass_assign_bulk_form",
      method: "POST",
      data: {
        all_results: this.parentCheckboxTarget.checked,
        accession_ids: this.accessionIdsValue,
        sts_ids: this.checkedStsIds,
        test_identifier: this.testIdentifierValue,
      },
    })
      .then((html) => {
        $("#mass_assign_bulk_form").html(html.data);

        if (document.querySelector("#mass_assign_bulk_form")) {
          this.handleBulkForm(document.querySelector("#mass_assign_bulk_form"));
        }
      })
      .finally(() => {
        e.target.disabled = false;
        e.target.querySelector(".spinner-border").classList.add("d-none");
      });
  }

  closeBulkForm(e) {
    e.preventDefault();

    e.target.classList.add("d-none");
    this.assignResultButtonTarget.classList.remove("d-none");

    const checkboxes = this.childCheckboxTargets;

    checkboxes.push(this.parentCheckboxTarget);
    checkboxes.forEach((e) => {
      if (e.disabled) e.disabled = false;
    });
    this.clearElement(this.parentFormTarget);
  }

  clickNextPencilIcon(specimenId) {
    const foundElement = this.pencilSpecimenTargets.find(
      (e) => e.dataset["turboFrame"] === specimenId,
    );
    const indexOfFoundElement =
      this.pencilSpecimenTargets.indexOf(foundElement);
    if (indexOfFoundElement >= 0) {
      const nextPencil = this.pencilSpecimenTargets[indexOfFoundElement + 1];
      nextPencil && nextPencil.click();
    }
  }

  closeButton() {
    const divElement = document.createElement("div");
    const buttonElement = document.createElement("button");
    const iconElement = document.createElement("i");
    const iconText = document.createTextNode("Close Test Entry");

    buttonElement.classList.add(...["btn", "btn-link", "text-danger"]);
    iconElement.appendChild(iconText);
    iconElement.classList.add(...["fa", "fa-times-circle"]);

    buttonElement.appendChild(iconElement);
    divElement.appendChild(buttonElement);
    return divElement;
  }

  plusClick(e) {
    let iconElement = e.target.firstElementChild;

    if (e.target.nodeName === "I") {
      iconElement = e.target;
    }

    let aElement = iconElement.parentElement;
    let spcimenFrameDataId = aElement.dataset["turboFrame"];

    if (this.checkExistFrame(spcimenFrameDataId, "specimenFrameData")) {
      this.changeDataIcon(iconElement, "fa-plus");
      this.clearElement(this.getFrameById(spcimenFrameDataId));
      e.preventDefault();
    } else {
      this.changeDataIcon(iconElement, "fa-minus");
    }
  }

  deleteSpecimenTestBlock(e) {
    e.preventDefault();

    let iconElement = e.target.firstElementChild;

    if (e.target.nodeName === "SPAN") {
      iconElement = e.target;
    }

    let buttonElement = iconElement.parentElement;

    const blockId = buttonElement.dataset.formDiv;
    const blockElement = this.specimenTestBlockTargets.find(
      (el) => el.id === blockId,
    );
    const ids = buttonElement.dataset["stsIds"];
    const parsedStsIds = JSON.parse(ids);

    dataConfirmModal.confirm({
      title: i18next.t("Delete Specimen Test Results"),
      text: i18next.t("Are you sure?"),
      commit: i18next.t("Delete"),
      cancel: i18next.t("Cancel"),
      zIndex: 10099,
      onConfirm: function () {
        axios({
          url: "destroy_test_results",
          method: "delete",
          data: { test_results: parsedStsIds },
        }).then((response) => {
          notify({
            status: response.data.status,
            message: response.data.message,
          });
          // TODO: Replace JQuery fadeOut with an Animate.css
          blockElement &&
            $(blockElement).fadeOut("slow", () => {
              blockElement.remove();
            });
        });
      },
      onCancel: function () {
        return;
      },
    });
  }

  changeDataIcon(iconElement, className) {
    iconElement.classList.remove("fa-plus");
    iconElement.classList.remove("fa-minus");

    iconElement.classList.add(className);
  }

  clearElement(element) {
    $(element).html("");
  }

  getFrameById(id) {
    return document.querySelector(`turbo-frame[id="${id}"]`);
  }

  checkExistFrame(id, frameId) {
    const frame = this.getFrameById(id);

    return frame && !!frame.querySelector(`#${frameId}`);
  }

  getIconElemenById(id) {
    const element = document.querySelector(
      `[data-mass-assign-results-target=plusSpecimen][data-turbo-frame=${id}]`,
    );

    return element.getElementsByTagName("i")[0];
  }

  editResults(e) {
    e.preventDefault();

    const firstSpecimen = this.pencilSpecimenTargets[0];

    firstSpecimen && firstSpecimen.click();
  }

  scrollToSpecimenForm(sts_ids) {
    document.getElementById(`form_div_${sts_ids.join("_")}`).scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }

  reloadSpecimensBlock() {
    let url = new URL(this.lazyPaginationTarget.src, window.location.origin);

    this.lazyPaginationTarget.disabled;
    this.specimensBlockTarget.innerHTML = "";
    url.searchParams.set("page", "1");
    this.lazyPaginationTarget.src = url.pathname + url.search;
    this.lazyPaginationTarget.enabled;
  }

  get isParentFormActive() {
    return this.parentFormTarget.hasChildNodes();
  }

  get checkedStsIds() {
    let stsIds = [];

    this.childCheckboxTargets.forEach((e) => {
      if (e.checked) {
        const ids = e.dataset["stsIds"];
        const parsedStsIds = JSON.parse(ids);
        stsIds.push(...parsedStsIds);
      }
    });
    return stsIds;
  }

  get allStsIds() {
    let stsIds = [];
    this.childCheckboxTargets.forEach((e) => {
      const ids = e.dataset["stsIds"];

      const parsedStsIds = JSON.parse(ids);

      stsIds.push(...parsedStsIds);
    });

    return stsIds;
  }
}
